import { DefaultState } from '@src/redux/types'

import {
  PRE_MODERATION_ALL,
  PRE_MODERATION_ASSIGNED,
  PRE_MODERATION_BY_ID,
  PRE_MODERATION_CHANGE_STATUS,
  PRE_MODERATION_HISTORY_CREATE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [PRE_MODERATION_ALL]: DefaultState<`${typeof API.PRE_MODERATION_ALL}`, 'get'>
  [PRE_MODERATION_ASSIGNED]: DefaultState<`${typeof API.PRE_MODERATION_ASSIGNED}`, 'get'>
  [PRE_MODERATION_CHANGE_STATUS]: DefaultState<`${typeof API.PRE_MODERATION_CHANGE_STATUS}`, 'put'>
  [PRE_MODERATION_HISTORY_CREATE]: DefaultState<`${typeof API.PRE_MODERATION_HISTORY_CREATE}`, 'post'>
  [PRE_MODERATION_BY_ID]: DefaultState<`${typeof API.PRE_MODERATION}{id}`, 'get'>
} = () => ({
  [PRE_MODERATION_ALL]: defaultState(),
  [PRE_MODERATION_ASSIGNED]: defaultState(),
  [PRE_MODERATION_BY_ID]: defaultState(),
  [PRE_MODERATION_CHANGE_STATUS]: defaultState(),
  [PRE_MODERATION_HISTORY_CREATE]: defaultState(),
})
